import Pages from "./Page/page";

function App() {
  return (
    <>
    <Pages/>
    </>
  );
}

export default App;
